import React from "react";
import { ArrowRight, Calendar } from "lucide-react";

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function FinalCTA() {
  return (
    <section
      id="final-cta-section"
      data-testid="final-cta-section"
      className="relative bg-[#1F2937] text-[#F7F9FB] py-24 lg:py-32 overflow-hidden"
    >
      {/* Decorative ridges */}
      <div className="absolute inset-0 -z-0 opacity-[0.12]">
        <svg
          viewBox="0 0 1200 600"
          preserveAspectRatio="none"
          className="h-full w-full"
          aria-hidden="true"
        >
          <path
            d="M0,400 L160,260 L320,360 L500,220 L680,340 L860,210 L1040,330 L1200,260 L1200,600 L0,600 Z"
            fill="#6FB04F"
          />
          <path
            d="M0,470 L140,360 L300,440 L480,320 L660,420 L820,310 L1000,410 L1200,350 L1200,600 L0,600 Z"
            fill="#2E89C4"
            opacity="0.65"
          />
        </svg>
      </div>

      <div className="relative max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#2E89C4]/40 bg-[#2E89C4]/10 text-[#2E89C4] text-xs font-semibold tracking-[0.15em] uppercase mb-8">
          <Calendar size={12} />
          Begrenzte Plätze pro Monat
        </div>

        <h2
          data-testid="final-cta-title"
          className="font-display text-4xl sm:text-5xl lg:text-7xl font-extrabold tracking-tight leading-[1.05]"
        >
          Lass uns gemeinsam{" "}
          <span className="text-[#2E89C4]">herausfinden,</span> was dein Körper
          wirklich braucht.
        </h2>

        <p className="mt-7 text-base lg:text-lg text-[#C7CFD9] max-w-2xl mx-auto leading-relaxed">
          Im kostenlosen Erstgespräch klären wir, ob und wie wir gemeinsam
          arbeiten – ohne Verpflichtung, ohne Verkaufsdruck.
        </p>

        <div className="mt-11 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            data-testid="final-cta-button"
            onClick={() => scrollTo("booking-section")}
            className="btn-primary group inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-base font-semibold w-full sm:w-auto"
          >
            Jetzt kostenloses Erstgespräch buchen
            <ArrowRight
              size={18}
              className="transition-transform group-hover:translate-x-1"
            />
          </button>
        </div>

        <p className="mt-6 text-xs text-[#F7F9FB]/50">
          Begrenzte Plätze pro Monat für persönliche Betreuung.
        </p>
      </div>
    </section>
  );
}
